import React from 'react'
import { CardBody } from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import './TotalParikami.css'

const TotalParikamiCardBody = () => {
    return (
        <CardBody className="card-body pt-0">
            <div className="right-side icon-right-primary">
                <i className="fa fa-user"></i>
                <div className="shap-block">
                    <div className="rounded-shap animate-bg-primary">
                        <i className='circle1'></i>
                        <i className='circle2'></i>
                    </div>
                </div>
            </div>
        </CardBody>
    );
};

export default TotalParikamiCardBody
